module.exports = __webpack_public_path__ + "img/taurus.85ea863c.svg";